import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `ComboObservacionesEyaculadoEliminado`, method: 'GET', body: null, token: token})
}
